exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-type-icon {\n  display: inline-block;\n  padding: 22px 15px 0 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/field/display-field-type/display-field-type.component.scss
// module id = ../../../../../src/app/thought-module/field/display-field-type/display-field-type.component.scss
// module chunks = main